module.exports = __webpack_public_path__ + "static/media/check.48f2226f.svg";